import { useEffect, useRef } from "react";
import { Button } from "@jsq/ds/core";
import { useFormContext } from "@jsq/ds/forms";
import { isLinkedOnboardingSubject } from "../CaseInformationStep/utils";
import { useEntityClientWizard } from "../context";

interface Props {
  onBack: () => void;
}

export const ProfileFormFooter = ({ onBack }: Props) => {
  const { setFooterContent, caseType, caseInfo, isProductLineLoading } =
    useEntityClientWizard();
  const { submitForm, isSubmitting } = useFormContext();

  const onBackRef = useRef(onBack);
  onBackRef.current = onBack;
  const submitRef = useRef(submitForm);
  submitRef.current = submitForm;

  const continueDisabled =
    isSubmitting ||
    (isLinkedOnboardingSubject(caseInfo ?? { isUnlinked: false }, caseType) &&
      isProductLineLoading);

  useEffect(() => {
    setFooterContent(
      <>
        <Button variant="neutral" onClick={() => onBackRef.current()} type="button">
          Back
        </Button>
        <Button
          variant="primary"
          disabled={continueDisabled}
          onClick={() => void submitRef.current()}
          type="button"
          data-testid="profile-continue"
        >
          Continue
        </Button>
      </>,
    );
    return () => setFooterContent(null);
  }, [setFooterContent, continueDisabled]);

  return null;
};
